// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/font/Eczar/Eczar-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/font/Poppins/Poppins-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* 에러 페이지에만 적용되는 폰트 정의 */
@font-face {
  font-family: "Error-Eczar";
  font-style: normal;
  font-weight: 800;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "Error-Poppins";
  font-style: normal;
  font-weight: 600;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-display: swap;
}
.error-page-container {
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  background: #121212;
  font-family: "Error-Poppins", sans-serif;
  padding: 1em;
  overflow: hidden;
}
.error-page-container .background-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  -webkit-user-select: none;
          user-select: none;
}
.error-page-container .background-wrapper h1 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  font-family: "Error-Eczar", serif;
  font-size: 60vmax;
  color: #282828;
  letter-spacing: 0.025em;
  margin: 0;
  transition: 750ms ease-in-out;
}
.error-page-container .error-link {
  border: 2px solid #555;
  padding: 0.5em 0.8em;
  position: fixed;
  z-index: 1;
  color: #555;
  text-decoration: none;
  display: flex;
  align-items: center;
  transition: 150ms;
}
.error-page-container .error-link svg > polyline {
  transition: 150ms;
}
.error-page-container .error-link:hover {
  color: #333;
  background: #dadada;
  border-color: transparent;
}
.error-page-container .error-link:hover svg > polyline {
  stroke: #000;
}
.error-page-container .error-link:hover + .background-wrapper > h1 {
  color: #dadada;
}
.error-page-container .error-text {
  color: #dadada;
  font-size: calc(1em + 3vmin);
  position: fixed;
  bottom: 1rem;
  right: 1.5rem;
  margin: 0;
  text-align: right;
  text-shadow: -1px -1px 0 #121212, 1px 1px 0 #121212, -1px 1px 0 #121212, 1px -1px 0 #121212;
}
@media screen and (min-width: 340px) {
  .error-page-container .error-text {
    width: 70%;
  }
}
@media screen and (min-width: 560px) {
  .error-page-container .error-text {
    width: 50%;
  }
}
@media screen and (min-width: 940px) {
  .error-page-container .error-text {
    width: 30%;
  }
}
@media screen and (min-width: 1300px) {
  .error-page-container .error-text {
    width: 25%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Error/Error.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,wBAAA;AACA;EACI,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,+DAAA;EACA,kBAAA;AAEJ;AACE;EACE,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,+DAAA;EACA,kBAAA;AACJ;AAEA;EACI,aAAA;EACA,YAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,wCAAA;EACA,YAAA;EACA,gBAAA;AAAJ;AAEI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;UAAA,iBAAA;AAAR;AAEQ;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,+CAAA;EACA,iCAAA;EACA,iBAAA;EACA,cAAA;EACA,uBAAA;EACA,SAAA;EACA,6BAAA;AAAZ;AAII;EACI,sBAAA;EACA,oBAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AAFR;AAIQ;EACI,iBAAA;AAFZ;AAKQ;EACI,WAAA;EACA,mBAAA;EACA,yBAAA;AAHZ;AAKY;EACI,YAAA;AAHhB;AAOQ;EACI,cAAA;AALZ;AASI;EACI,cAAA;EACA,4BAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,SAAA;EACA,iBAAA;EACA,2FAAA;AAPR;AASQ;EAVJ;IAWQ,UAAA;EANV;AACF;AAQQ;EAdJ;IAeQ,UAAA;EALV;AACF;AAOQ;EAlBJ;IAmBQ,UAAA;EAJV;AACF;AAMQ;EAtBJ;IAuBQ,UAAA;EAHV;AACF","sourcesContent":["/* 에러 페이지에만 적용되는 폰트 정의 */\n@font-face {\n    font-family: 'Error-Eczar';\n    font-style: normal;\n    font-weight: 800;\n    src: url('../../assets/font/Eczar/Eczar-ExtraBold.ttf') format('truetype');\n    font-display: swap;\n  }\n  \n  @font-face {\n    font-family: 'Error-Poppins';\n    font-style: normal;\n    font-weight: 600;\n    src: url('../../assets/font/Poppins/Poppins-SemiBold.ttf') format('truetype');\n    font-display: swap;\n  }\n\n.error-page-container {\n    height: 100vh;\n    width: 100vw;\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 9999;\n    background: #121212;\n    font-family: \"Error-Poppins\", sans-serif;\n    padding: 1em;\n    overflow: hidden;\n\n    .background-wrapper {\n        position: relative;\n        width: 100%;\n        height: 100%;\n        user-select: none;\n        \n        h1 {\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%) rotate(-45deg);\n            font-family: \"Error-Eczar\", serif;\n            font-size: 60vmax;\n            color: #282828;\n            letter-spacing: 0.025em;\n            margin: 0;\n            transition: 750ms ease-in-out;\n        }\n    }\n\n    .error-link {\n        border: 2px solid #555;\n        padding: 0.5em 0.8em;\n        position: fixed;\n        z-index: 1;\n        color: #555;\n        text-decoration: none;\n        display: flex;\n        align-items: center;\n        transition: 150ms;\n        \n        svg > polyline {\n            transition: 150ms;\n        }\n        \n        &:hover {\n            color: #333;\n            background: #dadada;\n            border-color: transparent;\n            \n            svg > polyline {\n                stroke: #000;\n            }\n        }\n        \n        &:hover + .background-wrapper > h1 {\n            color: #dadada;\n        }\n    }\n\n    .error-text {\n        color: #dadada;\n        font-size: calc(1em + 3vmin);\n        position: fixed;\n        bottom: 1rem;\n        right: 1.5rem;\n        margin: 0;\n        text-align: right;\n        text-shadow: -1px -1px 0 #121212, 1px 1px 0 #121212, -1px 1px 0 #121212, 1px -1px 0 #121212;\n        \n        @media screen and (min-width: 340px) {\n            width: 70%;\n        }\n        \n        @media screen and (min-width: 560px) {\n            width: 50%;\n        }\n        \n        @media screen and (min-width: 940px) {\n            width: 30%;\n        }\n        \n        @media screen and (min-width: 1300px) {\n            width: 25%;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
